import { Space, Avatar, Typography } from 'antd'

const { Text } = Typography

const AvatarInitials = ({ text, width = 32, height = 32, style }) => {
  const getInitials = (name) => {
    if (!name) return '?'
    const words = name.trim().split(' ')
    if (words.length === 1) return words[0].charAt(0).toUpperCase()
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase()
  }

  const getBackgroundColor = (name) => {
    if (!name) return '#1890ff'
    const colors = [
      '#f56a00', '#7265e6', '#ffbf00', '#00a2ae',
      '#1890ff', '#52c41a', '#eb2f96', '#722ed1'
    ]
    const charCodeSum = name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0)
    return colors[charCodeSum % colors.length]
  }

  return (
    <Avatar
      style={{
        backgroundColor: getBackgroundColor(text),
        width,
        height,
        fontSize: width * 0.4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      {getInitials(text)}
    </Avatar>
  )
}

const AvatarWithText = ({
  text,
  width,
  height,
  avatarStyles,
  textStyle,
}) => {
  return (
    <Space align="center" size={8}>
      <AvatarInitials
        text={text}
        width={width}
        height={height}
        style={avatarStyles}
      />
      <Text type="secondary" style={{ ...textStyle }}>
        {text ?? ''}
      </Text>
    </Space>
  )
}

export default AvatarWithText